const X_API_KEY = process.env.REACT_APP_X_API_KEY;
const ROOT_URL = process.env.REACT_APP_ROOT_API_URL;

export { ROOT_URL, X_API_KEY };
